import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    classData: null,
  },
  getters: {
    getClassData: (state) => {
      return state.classData;
    },
  },
  mutations: {
    setClassData(state, data) {
      state.classData = data;
    },
  },
  actions: {
    setClassData({ commit }, data) {
      commit("setClassData", data);
    },
  },
  modules: {},
});
